import { OopsCategoryContextMenu } from "src/app/core/components/categories/context-menu/categories-context-menu.model";

export const NewActionId = 'NEW'
export const SearchActionId = 'SEARCH'
export const SortActionId = 'SORT'

export const FormOfPaymentTypeContextMenu: OopsCategoryContextMenu[] = [
    {
        name: 'New',
        actionId: NewActionId,
    },
    {
        name: 'Search',
        actionId: SearchActionId
    },
    {
        name: 'Sort',
        actionId: SortActionId
    }    
]

export const FormOfPaymentIssuerContextMenu: OopsCategoryContextMenu[] = [
    {
        name: 'New',
        actionId: NewActionId,
    },
    {
        name: 'Search',
        actionId: SearchActionId
    },
    {
        name: 'Sort',
        actionId: SortActionId
    }        
]

export const PaymentAcquirerContextMenu: OopsCategoryContextMenu[] = [
    {
        name: 'New',
        actionId: NewActionId,
    },
    {
        name: 'Search',
        actionId: SearchActionId
    },
    {
        name: 'Sort',
        actionId: SortActionId
    }        
]
